import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';

import {vendorCodes} from 'modules/store/vendors';

import {invalidateAccounts} from 'modules/store/accounts';
import {TIMEOUT_STORE} from 'util/constants';

const
    mapFields = {
        google_account_id: 'googleAccountId'
    },
    transformEntitiesFn = account => {
        if (typeof account !== 'object') {
            throw new Error('transformGoogle needs an object to transform');
        }

        return {
            id:        account.id,
            name:      account.alias,
            reselling: account.reselling,
            vendor:    {
                selected: vendorCodes.gcloud,
                values:   {
                    googleAccountId: account.google_account_id,
                    groupingAccount: account.grouping_account,
                    parent:          account.parent,
                    account:         account.account
                }
            }
        };
    },
    transformEntitiesToSaveFn = account => ({
        name:              account.name,
        google_account_id: account.vendor.googleAccountId.toUpperCase()
    });


const exports = storeModuleFactory({
    name:             'googleAccounts',
    endpoint:         endpoints.accounts.google.endpoint,
    instanceEndpoint: endpoints.accounts.google.instanceEndpoint,
    callbackActions:  [{
        method: 'update',
        action: invalidateAccounts
    }],
    timeout: TIMEOUT_STORE.TIMEOUT_STORE_MEDIUM,
    transformEntitiesFn,
    transformEntitiesToSaveFn
});

exports.transformEntitiesFn = transformEntitiesFn;
exports.transformEntitiesToSaveFn = transformEntitiesToSaveFn;
exports.mapFields = mapFields;


module.exports = exports;




// WEBPACK FOOTER //
// ./src/modules/store/googleAccounts.js